import React, { useState, createContext, useContext } from "react";
import { cn } from "../../lib/utils";

const SelectContext = createContext();

export function Select({ value, onValueChange, children }) {
  const [open, setOpen] = useState(false);

  return (
    <SelectContext.Provider value={{ value, onValueChange, open, setOpen }}>
      <div className="relative">{children}</div>
    </SelectContext.Provider>
  );
}

export function SelectTrigger({ className, children }) {
  const { open, setOpen } = useContext(SelectContext);

  return (
    <button
      type="button"
      className={cn(
        "flex h-10 w-full items-center justify-between rounded-md border px-3 py-2 text-sm bg-white",
        className
      )}
      onClick={() => setOpen(!open)}
    >
      {children}
    </button>
  );
}

export function SelectValue({ placeholder }) {
  const { value } = useContext(SelectContext);

  return (
    <span className={value ? "" : "text-muted-foreground"}>
      {value || placeholder}
    </span>
  );
}

export function SelectContent({ children }) {
  const { open } = useContext(SelectContext);

  if (!open) return null;

  return (
    <div className="absolute top-full mt-1 w-full rounded-md border bg-white shadow-md z-50">
      {children}
    </div>
  );
}

export function SelectItem({ value, children }) {
  const { onValueChange, setOpen } = useContext(SelectContext);

  return (
    <div
      className="px-3 py-2 cursor-pointer text-sm hover:bg-gray-100"
      onClick={() => {
        onValueChange(value);
        setOpen(false);
      }}
    >
      {children}
    </div>
  );
}
